import { Component, OnInit, Input } from '@angular/core';
import { first } from 'rxjs/operators';
import {
  ItemViewProviderDirective,
  ItemView,
  NtapGlobalConstants,
  ActionComponent,
  Util
} from '@ntap/core';
import { DynamicFormService } from '@ntap/common';
import { IzvjestajDownloadService } from '../services/izvjestaj-dowload-content.service';

@Component({
  selector: 'app-generiraj-izvjestaj-action',
  template: `<p-button
    ntapDebounceClick
    [label]="label"
    [disabled]="disabled"
    (onClick)="executeAction()"
  ></p-button>`
})
export class AppGenerirajIzvjestajActionComponent
  extends ActionComponent
  implements OnInit
{
  @Input() format = 'xlsx';
  public label = '';
  public disabled = false;

  constructor(
    protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected documentsDownloadService: IzvjestajDownloadService,
    protected formService: DynamicFormService
  ) {
    super();
  }

  ngOnInit() {
    this.label = `${
      this.format.charAt(0).toUpperCase() + this.format.toLowerCase().slice(1)
    }`;
  }

  override executeAction() {
    if (!this.formService.formGroup.invalid) {
      this.disabled = true;

      const reportRequestParams = {};
      (reportRequestParams as any)[NtapGlobalConstants.ATTR_$mainType] = (
        this.itemViewProvider.viewState as any
      )[NtapGlobalConstants.ATTR_$mainType];
      (reportRequestParams as any)[
        Util.getFullAttrName('pis~izvjestaj', NtapGlobalConstants.ATTR_id)
      ] = (this.itemViewProvider.viewState as any)[
        Util.getFullAttrName('pis~izvjestaj', NtapGlobalConstants.ATTR_id)
      ];
      (reportRequestParams as any)['reportParams'] =
        this.formService.getFormValues();
      (reportRequestParams as any)['format'] = this.format;
      this.doDownload(reportRequestParams);
    }
  }

  doDownload(params: object) {
    this.documentsDownloadService
      .previewReport(params)
      .pipe(first())
      .subscribe(() => {
        this.disabled = false;
      });
  }
}
